import HomeLayout from 'layouts/HomeLayout'
import HomePC from '../../web/home/HomePC'
import './Home.scss'

const HomePage = () => {
  return (
    <HomeLayout>
      <HomePC />
    </HomeLayout>
  )
}

export default HomePage
